import { TypeProduct } from '@/core/generated-types';
import Script from 'next/script';
import { memo } from 'react';

export interface PlaykitSchemaProps {
  product: TypeProduct;
  slug: string;
}

const PlaykitSchema = ({ product, slug }: PlaykitSchemaProps) => {
  const url = `https://${process.env.NEXT_PUBLIC_BACKEND_DOMAIN}/products/${slug}`;

  return (
    <Script
      type="application/ld+json"
      id="playkit-schema"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'Play Kits',
              item: `https://${process.env.NEXT_PUBLIC_BACKEND_DOMAIN}/products/the-play-kits`,
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: `${product.fields.title}`,
              item: `${url}`,
            },
          ],
        }),
      }}
    />
  );
};

export default memo(PlaykitSchema);
